







import Vue from 'vue'
import style from './style.module.scss'

import { Discount } from '@/types/price-settings'

import cell from '@/components/root-components/product-price-setting/_common/cell.vue'
import iconButton from '@/components/root-components/product-price-setting/_common/icon-button.vue'

export default Vue.extend({
    name: 'percent-cell',
    components: {
        iconButton,
        cell
    },
    props: {
        data: {} as () => Discount,
        typeCode: String
    },
    data() {
        return {
            style: style
        }
    },
    methods: {
        updateFromCell(data: number) {
            this.data.Percent = data;
        },
        deleteRow() {
            this.$store.dispatch('deleteDiscount', { rowId: this.data.ParentId, discountId: this.data.Id, typeCode: this.typeCode })
        },
        onApply(data: number | string) {
            if(data || data === '' || data === 0) {
                this.$store.dispatch('addEmptyDiscountRow', { rowId: this.data.ParentId, typeCode: this.typeCode });
            }
        }
    }
})
